import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateConference } from "~pages/Conferences/types/upsertConference.ts";
import type { ConferenceResponse } from "~types/conference.ts";

export const useUpdateConference = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<ConferenceResponse, Error, UpdateConference>({
    mutationFn: async ({ conferenceId, ...updateData }) =>
      await request<ConferenceResponse>(`${sport}/o/${organizationId}/conferences/${conferenceId}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["conferences"] }),
        queryClient.invalidateQueries({ queryKey: ["conferences", sport, organizationId] }),
      ]);
    },
  });
};
